function escapeCell(val: string): string {
  const needsQuotes = /[",\n]/.test(val);
  return needsQuotes ? `"${val.replace(/"/g, '""')}"` : val;
}

export function toCsv(rows: Record<string, unknown>[], columns: string[]): string {
  if (rows.length === 0) return columns.map(escapeCell).join(',') + '\n';
  const headers = columns.map(escapeCell).join(',');
  const lines = rows.map((row) =>
    columns.map((col) => escapeCell(String(row[col] ?? ''))).join(',')
  );
  return [headers, ...lines].join('\n') + '\n';
}
